import Head from "next/head"
import Link from "next/link"
import Image from "next/image"
import { useRouter } from "next/router"
import { Routes } from "app/routes"
import { ErrorBoundary } from "app/core/components/ErrorBoundary"
import React, { ReactNode, Suspense } from "react"
import GracefulErrorFallback from "app/core/components/error-handlers/GracefulErrorFallback"
import LoadingIndicator from "app/core/components/LoadingIndicator"
import AppFooter from "app/core/components/page-layout/Footer"
import { useQueryErrorResetBoundary } from "@tanstack/react-query"

export type LayoutProps = {
  title?: string
  children: ReactNode
}

const LoginLayout = ({ title, children }: LayoutProps) => {
  const router = useRouter()
  const { reset } = useQueryErrorResetBoundary()
  const titleString = `Playerdash • ${title || ""}`
  return (
    <>
      <Head>
        <title key="title">{titleString}</title>
      </Head>

      <main className="mt-auto mb-auto">
        <ErrorBoundary
          FallbackComponent={GracefulErrorFallback}
          resetKeys={[router.asPath]}
          onReset={reset}
        >
          <div className="text-center mb-5 mt-5">
            <Link href={Routes.Home()}>
              <Image
                src="/logos/logo_slogan_transparent.png"
                alt="PlayerDash app logo"
                height={64}
                width={198}
                loading="eager"
              />
            </Link>
          </div>
          <Suspense fallback={LoadingIndicator()}>{children}</Suspense>
        </ErrorBoundary>
      </main>

      <AppFooter />

      <style>{`
        div#__next {
          height: 100vH;
          display: flex;
          flex-direction: column;
        }
      `}</style>
    </>
  )
}

export default LoginLayout
